import React, { Component } from 'react'
import { connect } from 'react-redux'
import PopupButton from 'UI/PopupButton'
import Button from 'UI/Button'
import Popup from "reactjs-popup";
import Select from 'react-select'
import { Checkbox } from 'material-ui';
import {
    getYourFileSuccess,
    getYourFileLoading,
    resetError,
    getYourFileFailure,
    getYourFilesDetails,
    currentActiveRequest,
    UpdateRequestParameter,
    solutionScopeChanged,
    pendingChanges,
    fetchVisibleSolutionInScopeValues,
    isSpendParameterPage   ,
    saveSpendParametersOnRedirect
} from 'actions/spendActions'
import Modal from 'reboron/OutlineModal'

import { CheckboxE, PopupButtonE } from 'UI/CustomComponents/Controls';
import { formatThousands, formatThousandsForStrings } from 'utils/Utils'
import { changeModalStyle, changeModalContentStyle, backdropStyle } from 'Constants'

const changeBackdropStyle = Object.assign({}, backdropStyle);
changeBackdropStyle.zIndex = '1050';

const alertModalStyle = Object.assign({}, changeModalStyle);
alertModalStyle.zIndex = '1060';
alertModalStyle.width = '33%';


class AccountParametersNewValueStory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            RequestIds: [],
            fileDetails: [],
            originalState: '',
            open: false,
            isActive: false,
            respnseMessage: '',
            isError: false,
            test: JSON.stringify(this.props.spendDetails.currentActiveRequest),
            cardPaymentOption: [{ label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' }],
            selectedSolutionScope: '',
            solutionScopeOption: [],
            //     { label: "Buying", value: "Buying" },
            //     { label: "Buying and Invoicing", value: "Buying and Invoicing" },
            //     { label: "Commerce Automation", value: "Commerce Automation" },
            //     { label: "SCC", value: "SCC" },
            //     { label: "Supplier Choice", value: "Supplier Choice" },
            //     { label: "SNAP", value: "SNAP" },
            //     { label: "DSN", value: "DSN" },
            //     { label: "RISE", value: "RISE" },                
            // ],
            solutionInScopeFlag: false,
            modalDesc: 'Do you want to apply Solution in Scope changes to the Buyer Supplier Enablement Recommendations and Enablement Waves?'
        }
        this.handleParameterCheckChanged = this.handleParameterCheckChanged.bind(this)
        this.handleSolutionScopeChange = this.handleSolutionScopeChange.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleSaveParameter = this.handleSaveParameter.bind(this);
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
        //this.closePopUp = this.closePopUp.bind(this)
        this.newVariable = 0
    }

    showModal() {
        this.refs['alert'].show()
    }

    hideModal(action) {
        this.refs[action].hide()
    }

    componentWillUnmount() {		
		setTimeout(() => {
			//this.props.pendingChanges(null);
			this.props.isSpendParameterPage(false);
		}, 1000);
	}

    componentDidMount() {
        // console.log("componentDidMount called")
        this.props.isSpendParameterPage(true);
        this.setState({
            test: JSON.stringify(this.props.spendDetails.currentActiveRequest)
        })

        /////// Load Solution in scope dropdown value ////////////////////
        this.props.fetchVisibleSolutionInScopeValues().then((response) => {
            if (response.status === 200) {
                if (response.data.Result.length === 0) {
                    this.setState({ responseMessage: this.props.content.noRecords, isLoading: false, isError: true });
                }
                else
                {
                    console.log("api data-----------", response.data.Result)
                    var scopeValues=[];
                    if (response.data.Result !== null) {
                        response.data.Result.forEach(item => {
                            let value = Object.values(item)
                            scopeValues.push({ label: value[1], value: value[1] });
                        });
                    }                 

                    this.setState({ apiData: response.data.Result, solutionScopeOption: scopeValues,isLoading: false, responseMessage: '', isError: false });
                }
            }
            else {
                this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
            }
        }).catch((error) => {
            this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
        })
        ///////////////////
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.saveSpendParametersAfterRedirect !== nextProps.saveSpendParametersAfterRedirect && nextProps.saveSpendParametersAfterRedirect) {
			this.handleSaveParameter();
		}

        if (nextProps.spendDetails.currentActiveRequest !== undefined &&
            this.state.fileDetails !== undefined &&
            this.state.test !== undefined && this.state.test.length > 0) {
            var actualValue = JSON.parse(this.state.test);
            if (actualValue.DMC_ID !== this.state.fileDetails.DMC_ID) {
                this.setState({
                    test: JSON.stringify(nextProps.spendDetails.currentActiveRequest)
                })
            }


        }
        if (nextProps.spendDetails.currentActiveRequest !== this.props.fileDetails) {
            this.setState({
                fileDetails: nextProps.spendDetails.currentActiveRequest
            })
        }
    }


    // closePopUp(action) {
    //     if (action === "test") {
    //         var actualValue = JSON.parse(this.state.test);
    //         this.props.spendDetails.currentActiveRequest = actualValue;
    //         this.props.currentActiveRequest(actualValue);
    //         this.setState({ fileDetails: actualValue })
    //     }
    //     this.setState({ open: !this.state.open })
    //     //     }
    //     // else if (this.props.spendDetails !== undefined &&
    //     //     this.props.spendDetails.currentActiveRequest !== undefined) {
    //     //     this.setState({
    //     //         fileDetails: this.props.spendDetails.currentActiveRequest
    //     //     }, () => { this.setState({ open: !this.state.open }) })

    //     // }
    // }

    handleParameterCheckChanged(e) {

        var checkBoxState = this.state.fileDetails;


        switch (e.target.name) {
            case this.props.content.transactionEligible:
                checkBoxState.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.unclassifiedEligible:
                checkBoxState.UNCLASSIFIED_AUTOMATION_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.sCCEligible:
                checkBoxState.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.fieldglass:
                checkBoxState.FIELD_GLASS_SCOPE = e.target.checked;
                checkBoxState.FIELD_GLASS_ELIGIBLE = (e.target.checked === false ? false : this.state.fileDetails.FIELD_GLASS_ELIGIBLE);
                break;
            case this.props.content.fieldglassEligible:
                checkBoxState.FIELD_GLASS_ELIGIBLE = (this.state.fileDetails.FIELD_GLASS_SCOPE === false ? false : e.target.checked);
                break;
            case this.props.content.cardPaymentInScope:
                checkBoxState.CARD_PAYMENT_INSCOPE = e.target.checked;
                break;
        }
        this.props.pendingChanges(true)
        this.setState({ fileDetails: checkBoxState });

    }

    onChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.ANNUAL_TRANSACTION_MAX = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }   
    

    onCardPaymentInScopeChange(value) {
        var textBoxState = this.state.fileDetails;

        textBoxState.CARD_PAYMENT_INSCOPE = value === "Yes" ? true : false;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    

    handleSaveParameter() {
        this.hideModal("alert")
        this.setState({ respnseMessage: '', isError: false })

        console.log("filedetails :", this.state.fileDetails);

        var currentUpdate = this.state.fileDetails.ANNUAL_TRANSACTION_MAX.toString().replace(/^\D+/g, '');
        this.state.fileDetails.ANNUAL_TRANSACTION_MAX = currentUpdate

        var termRationalizationValue = this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD = termRationalizationValue

        var discountThresholdValue = this.state.fileDetails.DISCOUNT_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.DISCOUNT_THRESHOLD = discountThresholdValue

        var lowInvoiceCountValue = this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD = lowInvoiceCountValue

        var cardPaymentInScopeValue = this.state.fileDetails.CARD_PAYMENT_INSCOPE;
        this.state.fileDetails.CARD_PAYMENT_INSCOPE = cardPaymentInScopeValue

        var termRationalizationValue = this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD = termRationalizationValue

        var termRationalizationValue = this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD = termRationalizationValue

        var solutionInScope = this.state.fileDetails.SOLUTION_IN_SCOPE;
        this.state.fileDetails.SOLUTION_IN_SCOPE = solutionInScope

        this.props.UpdateRequestParameter(this.state.fileDetails).then(response => {
            if (response.status === 200) {
                this.setState({
                    isError: false,
                    respnseMessage: 'Parameter/s updated successfully',
                    test: JSON.stringify(this.state.fileDetails),
                    solutionInScopeFlag: false
                })
                this.props.currentActiveRequest(this.state.fileDetails);
                this.props.pendingChanges(null)
                //this.setState({ open: !this.state.open })
                //this.closePopUp('close');
            }
            else {
                this.setState({
                    isError: true,
                    respnseMessage: 'An error has occured'
                })
            }
            this.props.saveSpendParametersOnRedirect(false);
        }).catch((error) => {
            this.setState({
                isError: true,
                respnseMessage: 'An error has occured'
            })
        })
    }

    handleSolutionScopeChange(value) {
        var objFileDetails = this.state.fileDetails;

        objFileDetails.SOLUTION_IN_SCOPE = value.label;
        this.props.solutionScopeChanged(value.label)
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: objFileDetails, isError: true, respnseMessage: 'Warning! Buyer Supplier Enablement Recommendations will be changed.', solutionInScopeFlag: true
        });
    }

    render() {
        var displayInfoDesc = (itemDesc) => {
            return (
                <div>
                    <Popup className="report-tooltip"
                        trigger={<span className='value__information' />}
                        position="bottom right"
                        on="hover"
                    >
                        {itemDesc}
                    </Popup>
                </div>
            )
        };
        //onClick={() => this.showModal('AccountParameters')}

        return (
            // this.props.spendDetails !== undefined && this.props.spendDetails.currentActiveRequest !== undefined && this.props.spendDetails.currentActiveRequest !== "" ?
                <div className="grid-x">
                    <div className="medium-12 pb20 pt20">
                        <div className="grid-x">
                            <div className="medium-1"></div>
                            <div style={{ display: 'flex', justifyContent: 'center' }} className="medium-10">
                                {this.state.isError ?
                                    <div style={{ margin: '0 0 0.5rem', color: 'red' }}>{this.state.respnseMessage}</div> :
                                    <div style={{ margin: '0 0 0.5rem', color: '#4fb81c' }}>{this.state.respnseMessage}</div>
                                }
                            </div>
                            <div style={{ paddingLeft: '5px' }} className="float-left medium-1">
                                <button
                                    className='hand-cursor'
                                    type="submit"
                                    onClick={this.state.solutionInScopeFlag ? this.showModal : this.handleSaveParameter}
                                    content={this.props.content.saveButton}
                                    color ><img width="25" src="images/save_active.svg" /></button>
                            </div>
                        </div>
                    </div>
                    <div className="medium-1"></div>
                    <div style={{ backgroundColor: '#fafafa' }} className="medium-10">
                        <div className="grid-x">

                            <div style={{ fontWeight: 'bold' }} className="medium-12 title pt15 pl5">
                                {this.props.content.enablementInsight}
                            </div>
                            <div className="medium-12">
                                <div className="grid-x pt5">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.inScopeSolution}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.inScopeSolution)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
                                        <Select
                                            className="border-with-DD dropDownContent"
                                            id='aribaNetworkMatched'
                                            autocomplete='true'
                                            value={this.state.solutionScopeOption.filter(
                                                option => option.value === this.state.fileDetails.SOLUTION_IN_SCOPE
                                            )}
                                            onChange={value => this.handleSolutionScopeChange(value)}
                                            options={this.state.solutionScopeOption}
                                            isSearchable={false}
                                            noOptionsMessage={() => null} />
                                    </div>
                                </div>
                            </div>

                            <div style={{ fontWeight: 'bold' }} className="medium-12 pt15 pl5 title">
                                {this.props.content.productScope}
                            </div>
                            <div className="medium-12 pt5">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.transactionEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.transactionEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.transactionEligible}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE !== undefined ? this.state.fileDetails.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE : false} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.transactionEligible} value={this.props.content.transactionEligible} />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.unclassifiedEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.unclassifiedEligible)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.unclassifiedEligible}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.UNCLASSIFIED_AUTOMATION_ELIGIBLE !== undefined ? this.state.fileDetails.UNCLASSIFIED_AUTOMATION_ELIGIBLE : false} 
                                                onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.unclassifiedEligible} 
                                                value={this.props.content.unclassifiedEligible} />
                                        </div>
                                    </div>
                                </div>  

                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.sCCEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.sCCEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.sCCEligible} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE !== undefined ? this.state.fileDetails.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE : false}
                                                name={this.props.content.sCCEligible} value={this.props.content.sCCEligible} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.fieldglass}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.fieldglassDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.fieldglass} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.FIELD_GLASS_SCOPE !== undefined ? this.state.fileDetails.FIELD_GLASS_SCOPE : false}
                                                name={this.props.content.fieldglass} value={this.props.content.fieldglass} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.fieldglassEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.fieldglassEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: this.state.fileDetails.FIELD_GLASS_SCOPE === true ? '#008fd3' : '#f7f7f7' }} id={this.props.content.fieldglassEligible} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.FIELD_GLASS_ELIGIBLE !== undefined ? this.state.fileDetails.FIELD_GLASS_ELIGIBLE : false}
                                                name={this.props.content.fieldglassEligible} value={this.props.content.fieldglassEligible} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                                
                        </div>
                    </div>
                    <div className="medium-1"></div>
                    <div>
                        <Modal
                            ref="alert"
                            modalStyle={alertModalStyle}
                            contentStyle={changeModalContentStyle}
                            backdropStyle={changeBackdropStyle}
                        >
                            <div className="grid-x grid-padding-x change-popup">
                                <div className="medium-12">
                                    <button onClick={() => this.hideModal("alert")} className="close" />
                                </div>
                                <div className="medium-12 pt15">
                                    {this.state.modalDesc}
                                </div>
                                <div className="medium-12 popupOkBtn pt10">
                                    <div className="float-right">
                                        <div className="float-left"><Button
                                            content={"Yes"}
                                            onClick={this.handleSaveParameter}
                                            color /></div>
                                        <div className="float-left"><Button
                                            content={"Close"}
                                            onClick={() => this.hideModal("alert")}
                                            color /></div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div >
                // :
                // <div className="grid-x">
                //     <div className="medium-12">
                //         {this.props.content.noActiveRequestFile}
                //     </div >
                // </div >
        )
    }
}
const mapStateToProps = state => {
    return {
        // language: state.language,
        userData: state.valueStory,
        user: state.default,
        content: state.content.spendAnalysis.accountParameters,
        validation: state.content.validation,
        Industries: state.content.discovery.form.industries,
        spendDetails: state.spendDetails,
        saveSpendParametersAfterRedirect : state.saveSpendParametersOnRedirect.changes
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getYourFileLoading: bool => dispatch(getYourFileLoading(bool)),        
        UpdateRequestParameter: requestDetails => dispatch(UpdateRequestParameter(requestDetails)),
        currentActiveRequest: (requestDetails) => dispatch(currentActiveRequest(requestDetails)),
        solutionScopeChanged: (val) => dispatch(solutionScopeChanged(val)),
        pendingChanges: (val) => dispatch(pendingChanges(val)),
        fetchVisibleSolutionInScopeValues: () => dispatch(fetchVisibleSolutionInScopeValues()),
        isSpendParameterPage: obj => dispatch(isSpendParameterPage(obj)),
        saveSpendParametersOnRedirect: changes => dispatch(saveSpendParametersOnRedirect(changes)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountParametersNewValueStory)
